import { fetchStoreTransactionUrl, registerStoresDailyCheckUrl } from "../../../../api/endpoints";
import "../../../../styles/stores/makeTransactions/checkSales.css";
import { useSelector, useDispatch } from "react-redux";

import { useLayoutEffect, useState } from "react";
import Spinner, { ButtonLoader } from "../../../../components/uxCollections/Loaders";
import { setStore } from "../../../../slice/storeSlice";
import { syncOfflineQueue } from "../../../../tools/synOfflineQueue";
import PDFGenerator from "./PDFGenerator";
import { jsPDF } from "jspdf";
import { getSalesReport } from "./utils/dataService";
import { uiAlert } from "../../../../components/alerts/customAlert/uiAlert";
import DailySalesCheck from "./CheckSalesDisplay";

export const salesCheckFunction = (todaysTransaction) => {
  //saveCheckedSalesAndSendToEmail();
  let listOfItems = [];
  let revenueDistribution = {
    cash: 0,
    card: 0,
    mobilePay: 0,
  };
  let totalDiscount = 0; /* will be used to calculate total discount given on each product sold today */
  let totalVAT = 0;
  todaysTransaction.forEach((transaction) => {
    // the total discount
    totalDiscount += transaction.transactionDetails.discount ? transaction.transactionDetails.discount : 0;
    totalVAT += transaction.transactionDetails.vat ? transaction.transactionDetails.vat : 0;

    if (transaction.operationType.whichOperation === "cash") {
      transaction.products.forEach((product) => {
        listOfItems.push({ ...product, transactionType: "cash", balance: 0, paid: product.totalAmount });
      });
    } else {
      transaction.products.forEach((product) => {
        listOfItems.push({
          ...product,
          transactionType: "loan",
          balance: transaction.operationType.balance / transaction.products.length,
          paid: (transaction.transactionDetails.deliveryStatus === "returned" ? 0 : transaction.operationType.intialPayment) / transaction.products.length,
        });
      });
    }
    /* updating the revenue distribution list */

    if (transaction.transactionDetails.paymentMode === "cash") {
      if (transaction.operationType.whichOperation === "cash") {
        revenueDistribution.cash += transaction.transactionDetails.totalAmount;
      } else {
        revenueDistribution.cash += transaction.transactionDetails.deliveryStatus === "returned" ? 0 : transaction.operationType.intialPayment;
        /*  revenueDistribution.cash += transaction.operationType.clearedAmount ? transaction.operationType.clearedAmount : 0; */
      }
    } else if (transaction.transactionDetails.paymentMode === "card") {
      if (transaction.operationType.whichOperation === "cash") {
        revenueDistribution.card += transaction.transactionDetails.totalAmount;
      } else {
        revenueDistribution.card += transaction.transactionDetails.deliveryStatus === "returned" ? 0 : transaction.operationType.intialPayment;
        /*     revenueDistribution.card += transaction.operationType.clearedAmount ? transaction.operationType.clearedAmount : 0; */
      }
    } else if (transaction.transactionDetails.paymentMode === "mobilePay") {
      if (transaction.operationType.whichOperation === "cash") {
        revenueDistribution.mobilePay += transaction.transactionDetails.totalAmount;
      } else {
        revenueDistribution.mobilePay += transaction.transactionDetails.deliveryStatus === "returned" ? 0 : transaction.operationType.intialPayment;
        /* revenueDistribution.mobilePay += transaction.operationType.clearedAmount ? transaction.operationType.clearedAmount : 0; */
      }
    }
  });

  console.log(revenueDistribution, "revenue distribution");

  let eachItemAndQuantity = [];
  listOfItems.forEach((item) => {
    if (eachItemAndQuantity.length === 0) {
      !item.returned && eachItemAndQuantity.push({ productID: item.id, name: item.name, quantity: item.quantity });
    } else {
      let index = eachItemAndQuantity.findIndex((eachItem) => eachItem.productID === item.id);
      if (index === -1) {
        !item.returned && eachItemAndQuantity.push({ productID: item.id, name: item.name, quantity: item.quantity });
      } else {
        !item.returned && (eachItemAndQuantity[index].quantity += item.quantity);
      }
    }
  });

  /* creating store income breakdown  */

  const incomeBreakdown = todaysTransaction.reduce(
    (acc, currentTransaction) => {
      if (currentTransaction.operationType.whichOperation === "cash") {
        acc.incomeFromSoldProducts += currentTransaction.transactionDetails.totalAmount;

        return acc;
      } else {
        acc.amountOnLoan += currentTransaction.transactionDetails.deliveryStatus === "returned" ? 0 : currentTransaction.operationType.balance;
        acc.incomeFromSoldProducts += currentTransaction.transactionDetails.deliveryStatus === "returned" ? 0 : currentTransaction.operationType.intialPayment;

        return acc;
      }
    },
    {
      incomeFromSoldProducts: 0,
      amountOnLoan: 0,
    },
  );

  return { listOfItems, eachItemAndQuantity, revenueDistribution, incomeBreakdown, totalDiscount, totalVAT };
};

const CheckSales = ({ closeModal, currency }) => {
  const [listOfItems, setListOfItems] = useState(); /* array of objects */
  const [eachItemAndQuantity, setEachItemAndQuantity] = useState(); /* array of objects */
  const [revenueDistribution, setRevenueDistribution] = useState(); /* object */
  const [incomeBreakdown, setIncomeBreakdown] = useState(); /* object */
  const [clearLoanDistribution, setClearLoanDistribution] = useState();
  const [isLoading, setIsLoading] = useState(true); //
  //will be deleted
  const [showTestPDF, setShowTestPDF] = useState(false);
  const [salesData, setSalesData] = useState(null);
  const [sendingEmail, setSendingEmail] = useState(false); // to show loading when sending email
  const [totalVAT, setTotalVAT] = useState(0);
  const [isGenerating, setIsGenerating] = useState(false);
  const [itemCount, setItemCount] = useState(0);
  const { store } = useSelector((state) => state.store);
  const [discount, setDiscount] = useState(0); // to hold the total discount given on each product sold today
  const { count, queue } = useSelector((state) => state.offlineQueue);
  const [todaysTransactions, setTodaysTransactions] = useState(null);
  const { user } = useSelector((state) => state.webStoreUser);
  const currenyCode = user.userCountryCurrencyCode;
  const dispatch = useDispatch();
  console.log(currenyCode, "currenyCode");

  useLayoutEffect(() => {
    const loadData = async () => {
      try {
        const data = await getSalesReport();
        setSalesData(data);
        setItemCount(data?.items?.length || 0);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    loadData();
    if (count) {
      console.log("syncing offline queue before checking sales");

      syncOfflineQueueFunc();
    } else {
      fetchTodayTransactions();
    }
  }, []);

  const syncOfflineQueueFunc = async () => {
    try {
      await syncOfflineQueue();
      await fetchTodayTransactions();
    } catch (error) {
      uiAlert("Error syncing offline queue. Please try again later.", "error");
    }
  };

  const fetchTodayTransactions = async () => {
    try {
      let response = await fetch(fetchStoreTransactionUrl + store._id, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      if (response.ok) {
        let { todaysTransactions, todaysClearedLoan, todaysExpenses, clearloanDistribution } = await response.json();
        console.log(todaysTransactions, todaysClearedLoan, todaysExpenses);

        let { listOfItems, eachItemAndQuantity, revenueDistribution, incomeBreakdown, totalDiscount, totalVAT } = salesCheckFunction(
          todaysTransactions,
          todaysExpenses,
          todaysClearedLoan,
        );
        console.log({
          listOfItems,
          eachItemAndQuantity,
          revenueDistribution,
          incomeBreakdown,
          totalDiscount,
          totalVAT,
        });

        console.log(totalDiscount, "total discount given on each product sold today");
        setTotalVAT(totalVAT);
        setDiscount(totalDiscount);
        setClearLoanDistribution(clearloanDistribution);
        setIncomeBreakdown({ ...incomeBreakdown, expenses: todaysExpenses, clearedLoan: todaysClearedLoan, store });
        dispatch(setStore(store));
        setRevenueDistribution(revenueDistribution);
        setEachItemAndQuantity(eachItemAndQuantity.sort((a, b) => b.quantity - a.quantity));
        setListOfItems(listOfItems);
        todaysTransactions && setTodaysTransactions(todaysTransactions);
      } else {
        /* alert */
        uiAlert("error fetching transactions", "error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const saveCheckedSalesAndSendToEmail = async (pdfBlob) => {
    console.log("running save checked sales and send to email");
    /* check if store has updated their closing hour */
    let daysOfWeek = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

    if (store.openingHoursUpdated && !store.isDailySalesCheckRegistered) {
      // check if no product was sold else return

      if (listOfItems.length === 0) {
        alert("No product was sold today");
        return;
      }

      let todaysDay = daysOfWeek[new Date().getDay()];

      let storesClosingTime = parseInt(store.openingHours[todaysDay].to.split(":")[0]);

      // build a Date for “today at closing time”
      const now = new Date();
      const [h, m] = store.openingHours[todaysDay].to.split(":").map(Number);
      const closingTime = new Date(now);
      closingTime.setHours(h, m, 0, 0);

      console.log(closingTime, now, now >= closingTime, "store opening hours");

      /* check if current time is move than store closing time. */
      let currentTime = parseInt(new Date().getHours()) + (parseInt(new Date().getMinutes()) > 30 ? 1 : 0); /* approximating */
      console.log(parseInt(currentTime), parseInt(storesClosingTime));

      if (parseInt(currentTime) > storesClosingTime) {
        /* get the current transactions and evaluate the sales  */
        try {
          setSendingEmail(true);
          let response = await fetch(fetchStoreTransactionUrl + store._id, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          });

          if (response.ok) {
            let { todaysTransactions, todaysClearedLoan, todaysExpenses } = await response.json();

            let { listOfItems, eachItemAndQuantity, revenueDistribution, totalDiscount, totalVAT } = salesCheckFunction(todaysTransactions);

            // create a body for the request
            const payload = {
              listOfItems,
              eachItemAndQuantity,
              revenueDistribution,
              incomeBreakdown,
              date: new Date(),
              todaysClearedLoan,
              todaysExpenses,
              webstoreUserEmail: user.email,
              totalDiscount,
              totalVAT,
            };

            // get pdf blob
            /* 
            const doc = await createMultiPagePDF(
              salesData,
              incomeBreakdown,
              listOfItems,
              revenueDistribution,
              eachItemAndQuantity,
              store.storeName,
              currenyCode,
              discount,
              totalVAT
            ); */
            /* const pdfBlob = doc.output("blob"); */

            // Create a FormData object to send the PDF blob
            const formData = new FormData();
            formData.append("pdf", pdfBlob, `sales-report-${new Date().toISOString().split("T")[0]}.pdf`);
            formData.append("payload", JSON.stringify(payload));

            /* register daily sales and send pdf to email */

            let response2 = await fetch(registerStoresDailyCheckUrl + store._id, {
              method: "POST",
              headers: {
                /* "Content-Type": "application/json", */
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
              body: formData,
            });

            if (response2.ok) {
              let { message, store, dailySalesChecked } = await response2.json();

              /* set store and notify */
              dispatch(setStore(store));
              uiAlert(message || "Your daily sales have been registered, and pdf sent to your admin email", "success");
            } else {
              uiAlert("error registering daily sales", "error");
            }
          } else {
            /* alert */
            uiAlert("error fetching transactions", "error");
          }
        } catch (error) {
          console.log(error);
        } finally {
          setSendingEmail(false);
        }
      } else {
        uiAlert("store stil open, only possible if store is closed. try again when store is closed" + ` after  ${store.openingHours[todaysDay].to}`, "warning");
        /*  alert("Please update your closing hour in your store settings");
        return; */
      }
    } else {
      uiAlert("Please update your closing hour in your store settings, or you have already registered your daily sales today", "warning");
      return;
    }
  };
  // testing pdf

  /*  const generatePDF = async () => {
    if (!salesData) return;

    setIsGenerating(true);
    try {
      // Log item count for debugging
      console.log(`Generating PDF with ${salesData.items.length} items`);

      const doc = await createMultiPagePDF(
        salesData,
        incomeBreakdown,
        listOfItems,
        revenueDistribution,
        eachItemAndQuantity,
        store.storeName,
        currenyCode,
        discount,
        totalVAT,
        todaysTransactions
      );
      doc.save(`${store.storeName}-sales-report-${new Date().toISOString().split("T")[0]}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setIsGenerating(false);
    }
  }; */
  const computed = {
    listOfItems,
    eachItemAndQuantity,
    revenueDistribution,
    incomeBreakdown,
    totalDiscount: discount,
    totalVAT,
  };

  return (
    <>
      {/*  <div className='checkSalesWrapper3'>
        <div className='checkSalesContainer2'>
          <h3 className='titleCheckSales'>Daily sales check on {store.storeName}</h3>
          {isLoading ? (
            <div style={{ position: "relative", height: "300px", width: "100%" }}>
              <Spinner position={"absolute"} />
            </div>
          ) : (
            <div style={{ position: "relative", height: "100%", width: "100%" }}>
              <div className='wrapperDivChecksales33'>
                <div className='ItemListDiv3'>
                  <h4 style={{ marginBottom: "20px" }}>List of items sold</h4>
                  <div className='stockPageTitle'>
                    <p style={{ width: "26px", flex: "0.5 " }}>Qty</p>
                    <p>Item</p>

                    <p>Unit price ({currency})</p>
                    <p>Total({currency})</p>
                    <p>Trans type</p>
                    <p>Paid ({currency})</p>
                    <p>Balance {currency} </p>
                  </div>

                  {listOfItems && listOfItems.map((item, index) => <EachItemOnSalesCheck key={index} isOdd={index} item={item} returned={item.returned} />)}
                </div>
                <div className='ItemQuantityDisplay'>
                  <h4 style={{ marginBottom: "20px", textAlign: "center" }}>Each item and sold quantity</h4>
                  <div className='quantityDisplayWrapper'>
                    {eachItemAndQuantity?.map((item, index) => (
                      <div key={index} className='eachquanityTagdiv'>
                        <p>{item.name}</p>
                        <div>
                          <p> {item.quantity} </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className='incomeBreakDownDiv'>
                <div className='incomeBreakDown'>
                  <h4 style={{ marginBottom: "20px" }}>Income breakdown ({currency})</h4>
                  <div className='breakDownDIv33'>
                    <span>Income from sold products</span>
                    <span style={{ fontSize: "1.2rem" }}> {incomeBreakdown?.incomeFromSoldProducts?.toLocaleString()} </span>
                  </div>
                  <div className='breakDownDIv33'>
                    <span>Amount from cleared loan</span>
                    <span>
                      {incomeBreakdown?.clearedLoan > 0 ? "+" : ""}
                      {incomeBreakdown?.clearedLoan?.toLocaleString()}
                    </span>
                  </div>
                  <div className='breakDownDIv33' style={{ color: "goldenrod" }}>
                    <span>Amount on loan</span>
                    <span>{incomeBreakdown?.amountOnLoan?.toLocaleString()} </span>
                  </div>
                  <div className='breakDownDIv33' style={{ color: "red" }}>
                    <span>Expenses</span>
                    <span>
                      {incomeBreakdown?.expenses > 0 ? "-" : ""}
                      {incomeBreakdown?.expenses?.toLocaleString()}{" "}
                    </span>
                  </div>
                  {discount ? (
                    <div className='breakDownDIv33' style={{ color: "red" }}>
                      <span>Discount</span>
                      <span>
                        {discount > 0 ? "-" : ""}
                        {discount?.toLocaleString()}{" "}
                      </span>
                    </div>
                  ) : null}

                  <div style={{ marginTop: "40px" }} className='payoutTotalDIv23'>
                    <p>Total</p>
                    <p>
                      {currency}{" "}
                      {(
                        incomeBreakdown?.clearedLoan +
                        incomeBreakdown?.incomeFromSoldProducts -
                        incomeBreakdown?.expenses -
                        Number(discount || 0)
                      )?.toLocaleString()}
                    </p>
                  </div>
                </div>
                <div className='RevenueDistribution'>
                  <h4 style={{ marginBottom: "20px", textAlign: "center" }}>Revenue distribution ({currency}) </h4>
                  <div className='eachPaymentDistributionWrapper'>
                    <div className='eachPaymentDistribution'>
                      <p>Cash</p>
                      <div>{(revenueDistribution?.cash + clearLoanDistribution?.cash)?.toLocaleString()}</div>
                    </div>
                    <div className='eachPaymentDistribution'>
                      <p>Card</p>
                      <div>{(revenueDistribution?.card + clearLoanDistribution?.card)?.toLocaleString()} </div>
                    </div>
                    <div className='eachPaymentDistribution'>
                      <p>MobilePay</p>
                      <div>{(revenueDistribution?.mobilePay + clearLoanDistribution?.mobilePay)?.toLocaleString()}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='sendEmailButtonDiv'>
                <button
                  onClick={() => {
                    generatePDF();
                  }}
                >
                  Download
                </button>
                {sendingEmail ? (
                  <button style={{ opacity: "0.7" }}>
                    <ButtonLoader />
                  </button>
                ) : (
                  <button onClick={() => saveCheckedSalesAndSendToEmail()}> Send to email</button>
                )}
              </div>
            </div>
          )}
          <div onClick={() => closeModal(false)} className='closeCheckSalesDiv'>
            Close
          </div>
        </div>
      </div> */}

      {isLoading ? (
        <div className='checkSalesWrapper3'>
          <div className='checkSalesContainer2'>
            <div style={{ position: "relative", height: "300px", width: "100%" }}>
              <Spinner position={"absolute"} />
            </div>
          </div>
        </div>
      ) : (
        todaysTransactions && (
          <DailySalesCheck
            transactions={todaysTransactions}
            computed={computed}
            date={new Date()}
            onClose={() => {
              closeModal();
            }}
            onEmail={(pdfBlob) => {
              saveCheckedSalesAndSendToEmail(pdfBlob);
            }}
          />
        )
      )}
    </>
  );
};

export default CheckSales;

const EachItemOnSalesCheck = ({ item, isOdd, returned = false }) => {
  return (
    <>
      <div style={{ opacity: returned ? "0.5" : "1" }} className={isOdd % 2 === 0 ? "eachItemSalesCheck87 " : "eachItemSalesCheck87 alternateCOlor"}>
        <p style={{ flex: "0.5 " }}> {item.quantity} </p>
        <p>{item.name}</p>
        <p>{item.soldUnitPrice.toLocaleString()}</p>
        <p> {item.totalAmount.toLocaleString()}</p>
        {item.transactionType === "loan" ? (
          <p style={{ color: "goldenrod", fontWeight: "600" }}>Loan</p>
        ) : (
          <p style={{ color: "green", fontWeight: "600" }}>Cash</p>
        )}
        <p>{item.paid.toLocaleString()}</p>
        <p>{item.balance.toLocaleString()}</p>
        {returned && <div></div>}
      </div>
    </>
  );
};

const logo = "https://res.cloudinary.com/ebuka1122/image/upload/v1747600616/StorelenseLogos/Group_2823_fsprsy.png";

// Convert URL to Data URL using fetch and FileReader
const drawRoundedImage = async (imgUrl, radius = 10) => {
  const img = new Image();
  img.crossOrigin = "Anonymous"; // If loading from a different origin
  img.src = imgUrl;

  await new Promise((resolve) => (img.onload = resolve));

  const size = 200; // Adjust size as needed
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;

  const ctx = canvas.getContext("2d");

  // Draw rounded rectangle path
  ctx.beginPath();
  ctx.moveTo(radius, 0);
  ctx.lineTo(size - radius, 0);
  ctx.quadraticCurveTo(size, 0, size, radius);
  ctx.lineTo(size, size - radius);
  ctx.quadraticCurveTo(size, size, size - radius, size);
  ctx.lineTo(radius, size);
  ctx.quadraticCurveTo(0, size, 0, size - radius);
  ctx.lineTo(0, radius);
  ctx.quadraticCurveTo(0, 0, radius, 0);
  ctx.closePath();
  ctx.clip();

  // Draw the image inside the clipped region
  ctx.drawImage(img, 0, 0, size, size);

  // Return base64 image
  return canvas.toDataURL("image/png");
};

// Create a PDF using jsPDF with multi-page support
/* const createMultiPagePDF = async (data, incomeBreakdown, listOfItems, revenueDistribution, eachItemAndQuantity, storeName, currenyCode, discount, totalVAT) => {
  console.log(
    incomeBreakdown,
    "income break",
    listOfItems,
    "list of items",
    revenueDistribution,
    "revenue dis",
    eachItemAndQuantity,
    "each item",
    storeName,
    "creating pdf and logging data"
  );

  const doc = new jsPDF();
  const { items = [], income = {}, distribution = {}, metadata = {} } = data;
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const margin = 14;
  const headerHeight = 15;
  const footerHeight = 10;
  let currentPage = 1;

  // PDF configuration
  const pdfConfig = {
    // Table config
    table: {
      startY: headerHeight + 25,
      rowHeight: 10,
      colWidths: [15, 30, 32, 25, 30, 25, 25],
      totalWidth: 182,
    },
    // Pagination config
    pagination: {
      contentAreaHeight: pageHeight - headerHeight - footerHeight - 20,
      maxItemsOnFirstPage: 8,
    },
    // Section spacing - reduced spacing values
    spacing: {
      afterTable: 5, // Reduced from 10
      afterQuantities: 5, // Reduced from 10
      betweenSections: 8, // Reduced from 15
      titleMargin: 15, // Space after section titles
    },
  };

  // Calculate rows per page dynamically
  pdfConfig.pagination.firstPageRows = Math.floor(
    (pdfConfig.pagination.contentAreaHeight - (pdfConfig.table.startY - headerHeight)) / pdfConfig.table.rowHeight
  );
  pdfConfig.pagination.subsequentPageRows = Math.floor((pdfConfig.pagination.contentAreaHeight - 40) / pdfConfig.table.rowHeight);

  // Function to add header to page
  const addHeader = async () => {
    // Add thin header with f9f9f9 background color
    doc.setFillColor(249, 249, 249); // #f9f9f9
    doc.rect(0, 0, pageWidth, headerHeight, "F");

    // Draw simple logo directly instead of using an image
    // Draw logo background
    doc.setFillColor(42, 87, 154); // Blue background
    // doc.rect(margin, 3, 10, 10, "F");

    // get logo
    // const logoDataUrl = await urlToDataUrl(logo);
    const logoDataUrl = await drawRoundedImage(logo);

    // Draw logo text
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.setTextColor(255, 255, 255);
    doc.addImage(logoDataUrl, "PNG", margin, 3, 42, 10);
    // doc.text("SR", margin + 5, 9, { align: "center" });

    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(80, 80, 80);
    // Move company name slightly right to make room for logo
    doc.text(storeName || "Sales Report", pageWidth / 2, 10, {
      align: "center",
    });
    doc.text(new Date().toLocaleDateString(), pageWidth - margin, 10, {
      align: "right",
    });
  };

  // Function to add footer to page
  const addFooter = (pageNum) => {
    // Add thin footer with f9f9f9 background color to match header
    doc.setFillColor(249, 249, 249); // #f9f9f9
    doc.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, "F");

    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(80, 80, 80);
    doc.text("Generated on " + new Date().toLocaleString(), margin, pageHeight - 4);
    doc.text(`Page ${pageNum}`, pageWidth / 2, pageHeight - 4, {
      align: "center",
    });
    doc.text(metadata?.reportId || "Report ID: SR-" + Date.now().toString().slice(-6), pageWidth - margin, pageHeight - 4, { align: "right" });
  };

  // Function to add a new page
  const addNewPage = async () => {
    // Add footer to current page
    addFooter(currentPage);

    // Add a new page
    doc.addPage();
    currentPage++;

    // Add header to new page
    await addHeader();

    return currentPage;
  };

  // Add header to first page
  await addHeader();

  // Title
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(0, 0, 0);
  doc.text(`Daily sales check on ${storeName}`, 105, headerHeight + 10, {
    align: "center",
  });

  // Section title and item count for debugging
  doc.setFontSize(11);
  doc.setFont("helvetica", "bold");
  doc.text(`List of items sold in (${currenyCode}) `, 14, headerHeight + 20);

  // Draw table header function
  const drawTableHeader = (yPos) => {
    // Set up header positions
    let xOffset = margin;

    // Draw header background
    doc.setFillColor(238, 238, 238);
    doc.rect(xOffset, yPos, pdfConfig.table.totalWidth, pdfConfig.table.rowHeight, "F");

    // Draw header text
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(0, 0, 0);

    // Draw header columns
    const headers = ["Qty", "Item", `Unit price `, `Total `, "Trans type", "Paid", "Balance"];

    headers.forEach((header, i) => {
      doc.text(header, xOffset + 2, yPos + 7);
      xOffset += pdfConfig.table.colWidths[i];
    });

    // Draw top border
    doc.setDrawColor(220, 220, 220);
    doc.line(margin, yPos, margin + pdfConfig.table.totalWidth, yPos);

    return yPos + pdfConfig.table.rowHeight;
  };

  // Initial position for first page
  let yPos = drawTableHeader(pdfConfig.table.startY);
  let itemIndex = 0;

  // Draw table data with pagination
  while (itemIndex < listOfItems.length) {
    // Check if we need a new page - only create a new page when we have more than 8 items
    const needsNewPage = itemIndex >= pdfConfig.pagination.maxItemsOnFirstPage && yPos + pdfConfig.table.rowHeight > pageHeight - footerHeight - 15;

    if (needsNewPage) {
      // Add footer to current page
      addFooter(currentPage);

      // Add a new page
      doc.addPage();
      currentPage++;

      // Add header to new page
      await addHeader();

      // Add section title on new page
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(0, 0, 0);
      doc.text(`List of items sold (continued) (${currenyCode})`, 14, headerHeight + 20);

      // Reset y position and draw table header on new page
      yPos = drawTableHeader(headerHeight + 25);
    }

    const item = listOfItems[itemIndex];

    // Set row background - alternating colors
    if (itemIndex % 2 === 1) {
      doc.setFillColor(230, 247, 255); // Light blue for even rows
      doc.rect(margin, yPos, pdfConfig.table.totalWidth, pdfConfig.table.rowHeight, "F");
    }

    let xOffset = margin;

    // Set text properties
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0);
    // check if item is returned draw a gray line acrros the box
    if (item.returned) {
      doc.setTextColor(120, 120, 120); // Red color for returned items
      doc.setLineWidth(0.5); // rgb(177, 179, 180)
      doc.setDrawColor(177, 179, 180); // gray color for the line
      doc.line(margin, yPos + 6, margin + pdfConfig.table.totalWidth, yPos + 5); // Draw line across the row
    } else {
      doc.setTextColor(0, 0, 0); // Reset text color for normal items
    }

    // Draw each cell
    doc.text(String(item.quantity || 0), xOffset + 2, yPos + 7);
    xOffset += pdfConfig.table.colWidths[0];

    doc.text(String(item.name || ""), xOffset + 2, yPos + 7);
    xOffset += pdfConfig.table.colWidths[1];

    doc.text(String(item.soldUnitPrice?.toLocaleString() || 0), xOffset + 2, yPos + 7);
    xOffset += pdfConfig.table.colWidths[2];

    doc.text(String(item.totalAmount?.toLocaleString() || 0), xOffset + 2, yPos + 7);
    xOffset += pdfConfig.table.colWidths[3];

    // Set green color for all transaction types if cash
    // Set gray color for returned items
    if (item.transactionType === "loan") {
      doc.setTextColor(255, 165, 0); // Orange color
    } else {
      doc.setTextColor(0, 128, 0); // Green color
    }
    doc.text(String(item.transactionType || ""), xOffset + 2, yPos + 7);
    if (item.returned) {
      doc.setTextColor(120, 120, 120); // gray color for returned items
      // doc.setLineWidth(0.5); // rgb(177, 179, 180)
      //  doc.setDrawColor(177, 179, 180); // gray color for the line
      // doc.line(margin, yPos + 6, margin + pdfConfig.table.totalWidth, yPos + 5); // Draw line across the row
    } else {
      doc.setTextColor(0, 0, 0); // Reset text color for normal items
    }
    // doc.setTextColor(0, 0, 0); // Reset text color back to black
    xOffset += pdfConfig.table.colWidths[4];

    doc.text(String(item.paid?.toLocaleString() || 0), xOffset + 2, yPos + 7);
    xOffset += pdfConfig.table.colWidths[5];

    doc.text(String(item.balance?.toLocaleString() || 0), xOffset + 2, yPos + 7);

    // Draw horizontal line
    doc.setDrawColor(220, 220, 220);
    doc.line(margin, yPos + pdfConfig.table.rowHeight, margin + pdfConfig.table.totalWidth, yPos + pdfConfig.table.rowHeight);

    yPos += pdfConfig.table.rowHeight;
    itemIndex++;
  }

  const tableEndY = yPos + pdfConfig.spacing.afterTable;

  // Calculate quantity section dimensions
  const quantityBoxHeight = Math.ceil(listOfItems.length / 5) * 30 + 20; // Reduced from 35 to 30 and 25 to 20

  // Calculate total height needed for all sections
  const incomeBreakdownHeight = 80; // Reduced from 100
  const totalHeightNeeded = tableEndY + quantityBoxHeight + incomeBreakdownHeight + pdfConfig.spacing.afterQuantities;

  // If we have 8 or fewer items, force everything on first page by adjusting spacing
  if (listOfItems.length <= 8) {
    // Add quantities section closer to the table
    const quantitiesY = tableEndY + pdfConfig.spacing.afterTable;
    addQuantitiesSection(doc, eachItemAndQuantity, quantitiesY + 8, margin, pageWidth, currenyCode);

    // Add income section closer to quantities section
    const incomeY = quantitiesY + quantityBoxHeight + pdfConfig.spacing.afterQuantities;
    addIncomeSection(doc, incomeBreakdown, revenueDistribution, incomeY + 14, margin, pageWidth, currenyCode, discount, totalVAT);
  } else {
    // For more than 8 items, use the original logic for pagination
    if (tableEndY + quantityBoxHeight > pageHeight - footerHeight - 20) {
      currentPage = await addNewPage();

      // Reset position for next section
      const newStartY = headerHeight + 25;

      // Add quantities section
      addQuantitiesSection(doc, eachItemAndQuantity, newStartY, margin, pageWidth, currenyCode);

      // Check if there's enough space for income section on the same page
      if (newStartY + quantityBoxHeight + 80 > pageHeight - footerHeight - 20) {
        currentPage = await addNewPage();

        // Add income section on the new page
        addIncomeSection(doc, incomeBreakdown, revenueDistribution, headerHeight + 25, margin, pageWidth, currenyCode, discount, totalVAT); // 25 before
      } else {
        // Add income section below quantities section
        addIncomeSection(
          doc,
          incomeBreakdown,
          revenueDistribution,
          newStartY + quantityBoxHeight + pdfConfig.spacing.afterQuantities + 10,
          margin,
          pageWidth,
          currenyCode,
          discount,
          totalVAT
        );
      }
    } else {
      // Add quantities section on the same page
      addQuantitiesSection(doc, eachItemAndQuantity, tableEndY + 6, margin, pageWidth, currenyCode);

      // Check if there's space for income section
      if (tableEndY + 6 + quantityBoxHeight + 80 > pageHeight - footerHeight - 20) {
        currentPage = await addNewPage();

        // Add income section on the new page
        addIncomeSection(doc, incomeBreakdown, revenueDistribution, headerHeight + 25, margin, pageWidth, currenyCode, discount, totalVAT);
      } else {
        // Add income section below quantities section
        addIncomeSection(
          doc,
          incomeBreakdown,
          revenueDistribution,
          tableEndY + quantityBoxHeight + pdfConfig.spacing.afterQuantities + 4,
          margin,
          pageWidth,
          currenyCode,
          discount,
          totalVAT
        );
      }
    }
  }

  // Add footer to the last page
  addFooter(currentPage);

  return doc;
}; */

// Function to add quantities section
const addQuantitiesSection = (doc, eachItemAndQuantity, startY, margin, pageWidth, currenyCode) => {
  const quantityBoxWidth = 182;

  // Group items by name and sum their quantities
  /*  const uniqueItems = {};
  items.forEach((item) => {
    const itemName = item.item || "Unknown";
    if (!uniqueItems[itemName]) {
      uniqueItems[itemName] = {
        name: itemName,
        qty: 0,
      };
    }
    uniqueItems[itemName].qty += item.qty || 0;
  }); */

  // Convert to array for display
  // const uniqueItemsArray = Object.values(uniqueItems);
  const uniqueItemsArray = eachItemAndQuantity;

  // Calculate height based on number of unique items - reduced padding
  const rowCount = Math.ceil(uniqueItemsArray.length / 5);
  const quantityBoxHeight = rowCount * 30 + 15; // Reduced from 35 to 30 and 20 to 15

  // Draw the box around all quantities with f9f9f9 background
  doc.setDrawColor(240, 240, 240);
  doc.setFillColor(249, 249, 249);
  doc.roundedRect(14, startY, quantityBoxWidth, quantityBoxHeight, 2, 2, "FD");

  // Add title INSIDE the box - reduced top margin
  doc.setFontSize(11);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(0, 0, 0);
  doc.text(`Each Item and Sold Quantity`, 105, startY + 10, {
    // Reduced from 12 to 10
    align: "center",
  });

  // Draw item quantities - adjusted starting position
  let quantityX = 25;
  let quantityY = startY + 18; // Reduced from 22 to 18

  // Define colors for quantity numbers (rotate through these colors)
  const quantityColors = [
    [0, 128, 0], // Green
    [0, 102, 204], // Blue
    [204, 102, 0], // Orange
    [153, 0, 153], // Purple
    [204, 0, 0], // Red
  ];

  // Now draw the circles and text ON TOP of the box
  uniqueItemsArray.forEach((item, index) => {
    if (index > 0 && index % 5 === 0) {
      quantityX = 25;
      quantityY += 30; // Reduced from 35 to 30
    }

    // Draw quantity circle with white background
    doc.setFillColor(255, 255, 255); // White
    const circleX = quantityX + 15;
    const circleY = quantityY + 12; // Reduced from 15 to 12
    const circleRadius = 9; // Reduced from 10 to 9

    doc.circle(circleX, circleY, circleRadius, "F");

    // Draw item label (above the circle) - centered
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0);
    doc.text(String(item.name), circleX, quantityY - 2, {
      // Added -2 to move closer to circle
      align: "center",
    });

    // Draw quantity with different colors (perfectly centered in circle)
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    const colorIndex = index % quantityColors.length;
    doc.setTextColor(quantityColors[colorIndex][0], quantityColors[colorIndex][1], quantityColors[colorIndex][2]);
    doc.text(String(item.quantity), circleX, circleY, {
      align: "center",
      baseline: "middle",
    });

    quantityX += 35;
  });

  // Reset text color
  doc.setTextColor(0, 0, 0);

  return quantityBoxHeight;
};

// Function to add income section
const addIncomeSection = (doc, income, distribution, startY, margin, pageWidth, currenyCode, discount, totalVAT) => {
  // Income breakdown title
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.text(`Income breakdown (${currenyCode}) `, 14, startY);

  // Income rows - reduced vertical spacing
  const incomeStartX = 14;
  let incomeY = startY + 12; // Reduced from 8 to 6
  const valueAlignX = 105;

  // Income from sold products
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(0, 0, 0);
  doc.text("Income from sold products", incomeStartX, incomeY);
  doc.text(String(income?.incomeFromSoldProducts?.toLocaleString() || "864853"), valueAlignX, incomeY, {
    align: "right",
  });
  incomeY += 7; // Reduced from 6 to 5

  // Amount from cleared loan
  doc.text("Amount from cleared loan", incomeStartX, incomeY);
  doc.text(`+ ${income?.clearedLoan?.toLocaleString() || "0"}`, valueAlignX, incomeY, {
    align: "right",
  });
  incomeY += 7; // Reduced from 6 to 5

  // Amount on loan (in orange)
  doc.setTextColor(255, 165, 0);
  doc.text("Amount on loan", incomeStartX, incomeY);
  doc.text(String(income?.amountOnLoan?.toLocaleString() || "0"), valueAlignX, incomeY, {
    align: "right",
  });
  incomeY += 7; // Reduced from 6 to 5

  // Expenses (in red)
  doc.setTextColor(255, 0, 0);
  doc.text("Expenses", incomeStartX, incomeY);
  doc.text(`- ${income?.expenses?.toLocaleString() || "0"}`, valueAlignX, incomeY, {
    align: "right",
  });
  incomeY += 7; // Reduced from 8 to 6

  //add discount always
  doc.text("Discount", incomeStartX, incomeY);
  doc.text(`-${discount?.toLocaleString() || "0"}`, valueAlignX, incomeY, {
    align: "right",
  });
  incomeY += 7; // Reduced from 8 to 6

  //Add total VAT
  doc.setTextColor(0, 0, 0);
  doc.text("Total VAT", incomeStartX, incomeY);
  doc.text(`${totalVAT?.toLocaleString() || "0"}`, valueAlignX, incomeY, {
    align: "right",
  });
  incomeY += 14; // Reduced from 10 to 8

  // Total box - white background with thin border
  doc.setFillColor(255, 255, 255);
  doc.setDrawColor(240, 240, 240);
  const totalBoxX = incomeStartX;
  const totalBoxY = incomeY;
  const totalBoxWidth = 90;
  const totalBoxHeight = 12; // Reduced from 15 to 12
  doc.roundedRect(totalBoxX, totalBoxY, totalBoxWidth, totalBoxHeight, 1, 1, "FD");

  // Total text - bold black
  doc.setFontSize(14);
  doc.setFont("courier", "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("Total", totalBoxX + 10, totalBoxY + 8);

  /* {currency} {(incomeBreakdown?.clearedLoan + incomeBreakdown?.incomeFromSoldProducts - incomeBreakdown?.expenses)?.toLocaleString()} */
  // Create spaced formatting exactly like in the image
  const totalValue =
    (parseInt(income?.clearedLoan) + parseInt(income?.incomeFromSoldProducts) - parseInt(income?.expenses) - parseInt(discount || 0))?.toLocaleString() || "0";

  // Insert commas and spaces between digits
  /*  let spacedTotal = "";
  for (let i = 0; i < totalValue.length; i++) {
    // Add comma after first 3 digits
    if (i === 3) {
      spacedTotal += ",";
    }
    spacedTotal += totalValue[i] + " ";
  }
  spacedTotal = spacedTotal.trim(); */

  // Position the total without currency symbol
  doc.text(` ${currenyCode} ${totalValue}`, totalBoxX + 80, totalBoxY + 8, { align: "right" });

  // Right side - Revenue distribution - adjusted positioning
  const revenueStartX = 112;
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(0, 0, 0);
  doc.text(`Revenue distribution (${currenyCode})`, 165, startY, {
    align: "right",
  });

  // Distribution boxes - kept close to the title
  const distTypes = [
    { label: "Cash", value: distribution?.cash || 0, color: [30, 58, 138] },
    { label: "Card", value: distribution?.card || 0, color: [75, 127, 82] },
    {
      label: "MobilePay",
      value: distribution?.mobilePay || 0,
      color: [101, 183, 65],
    },
  ];

  let distX = revenueStartX;

  distTypes.forEach((dist) => {
    // Label
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0);
    doc.text(dist.label, distX + 13, startY + 8, { align: "center" }); // Reduced from 10

    // Value box - moved closer to label
    doc.setFillColor(dist.color[0], dist.color[1], dist.color[2]);
    doc.roundedRect(distX, startY + 12, 26, 10, 1, 1, "F"); // Reduced from 15

    // Value text
    doc.setFontSize(10);
    doc.setTextColor(255, 255, 255);
    doc.text(String(dist?.value?.toLocaleString()), distX + 13, startY + 18, {
      // Adjusted to match new position
      align: "center",
    });

    distX += 30;
  });
};
